export default __webpack_public_path__ + "static/media/creative-portfolio.bfc63256.png";